// extracted by mini-css-extract-plugin
module.exports = {"MailchimpSubscribe":"NewsletterForm_MailchimpSubscribe__28HJI"};